import { ContentTypeEnum } from '@/enums/axios'
import request from '@/utils/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}
// 查询商品列表
export const getGoodsList = (data?: any) => request.get('/financial/mall/item/saas/list', data)

// 查询商品详情
export const getGoodsDetailApi = (data: any) =>
  request.post('/financial/mall/item/saas/detail', data, jsonHeaderConfig)

// 优惠券列表
export const getCoupon = (data: any) =>
  request.post('/financial/saasMallCoupon/listPage', data, jsonHeaderConfig)

// 查询购物车商品
export const getCartList = (data: any) => request.get('/financial/mall/shopCart/saas/list', data)

// 查询订单列表
export const getOrderList = (data: any) =>
  request.post('/financial/mall/order/search', data, jsonHeaderConfig)

// 购买商品(商详页)
export const tradeDetailBuy = (data: any) =>
  request.post('/financial/mall/trade/buy', data, jsonHeaderConfig)

// 购买商品(购物车)
export const shopCartBuy = (data: any) =>
  request.post('/financial/mall/trade/shopCartBuy', data, jsonHeaderConfig)

// 添加商品(购物车)
export const shopCartAdd = (data: any) =>
  request.post('/financial/mall/shopCart/saas/add', data, jsonHeaderConfig)
// 获取优惠券
export const getCouponListApi = (data: any) =>
  request.post(
    '/financial/saasMallCouponDistributeRecord/saas/calculatePrice',
    data,
    jsonHeaderConfig
  )

// 支付
export const tradePay = (data: any) =>
  request.post('/financial/mall/trade/pay', data, jsonHeaderConfig)
// 购买商品-检查是否同意了协议
export const goodsDealCheckApi = () => request.post('/financial/saasDeal/goodsDealCheck', {})
// 购买商品-商品管理购买协议-同意
export const goodsDealApi = (data: any) => request.post('/financial/saasDeal/goodsDeal', data)
// 预支付
export const doPayApi = (data: any) =>
  request.post('/financial/userAccount/business/doPay', data, jsonHeaderConfig)
// 银行卡预支付订单
export const prePayApi = (data: any) =>
  request.post('/financial/mall/trade/prePay', data, jsonHeaderConfig)
// 获取订单详情
export const orderDetailById = (id: string) =>
  request.get(`/financial/mall/order/detail?id=${id}`, {})

// 已购商品
// 已购商品数量
export const getBuyItemCount = () => request.get('/financial/mall/order/buyItemCount', {})
// 已购商品详情
export const buyItemDetail = (data: any) =>
  request.post('/financial/mall/order/buyItemDetail', data, jsonHeaderConfig)

// 协议签署验证码发送
export const sendCode = (code: number) => request.get(`/financial/userAgreement/sms/${code}`, null)

// 协议签署
export const signAgreen = (data: any) => request.get('/financial/userAgreement/sign', data)

// 是否已购买某应用
export const isBuyApp = (data: any) =>
  request.get('/admin/tenant/checkAppAuth', data, jsonHeaderConfig)

// 是否购买工作机
export const isBuyDevice = (data: any) =>
  request.post('/call/workPhone/isBuyDevice', data, jsonHeaderConfig)

// cps购买应用
export const payForCps = (data: any) =>
  request.post('/financial/mall/trade/payForCps', data, jsonHeaderConfig)

// 购买商品-商品管理购买协议-同意存证
export const goodsBuyDealAgree = (data: any) =>
  request.get('/financial/userAgreement/signV2', data, jsonHeaderConfig)
